import React, { ReactElement } from 'react';
import { baseTheme, Icon } from '@feast-it/ui/light';
import { useBreakpoint } from '../../hooks/media';
import { useIsDarkTheme } from '../../context/DarkThemeContext';
import { SliceLayout } from '../SliceLayout/SliceLayout';
import { ImagesWrapper } from './ImagesWrapper/ImagesWrapper';
import {
  BulletsDescWrapper,
  Container,
  ContentWrapper,
  DescriptionWrapper,
  MainContentWrapper,
  StyledHeading,
  TogatherIconWrapper,
} from './Hero.styled';
import { BreadcrumbsV2 } from './Breadcrumbs/BreadcrumbsV2';
import { BreadcrumbV2 } from './Breadcrumbs/types';
import { EventDatePickerV2 } from './EventDatePicker';
import { EventTypeOptions } from './EventTypeOptions/EventTypeOptions';
import { SeoEventType } from '../../types';

interface HeroProps {
  breadcrumbs: BreadcrumbV2[];
  title: string;
  subtitle: string;
  imageSrc: string;
  vertical: string;
  descriptorVariable: any;
  eventTypes?: SeoEventType[] | null;
}

export function HeroV2({
  breadcrumbs,
  title,
  subtitle,
  imageSrc,
  vertical,
  descriptorVariable,
  eventTypes,
}: HeroProps): ReactElement {
  const isSmallBreakpoint = useBreakpoint(baseTheme.breakpoints.small);
  const isTablet = useBreakpoint(baseTheme.breakpoints.medium);
  const isDesktop = useBreakpoint(baseTheme.breakpoints.large);
  const isMobile = !isSmallBreakpoint && !isTablet && !isDesktop;
  const isDark = useIsDarkTheme();

  return (
    <SliceLayout backgroundColor="skyBlue">
      <Container>
        <TogatherIconWrapper>
          <Icon
            name="Togather"
            size={640}
            fill={isDark ? 'darkMediumGrey' : 'white'}
          />
        </TogatherIconWrapper>

        <ContentWrapper>
          <BreadcrumbsV2 breadcrumbs={breadcrumbs} />

          <MainContentWrapper color={isDark ? 'white' : 'black'}>
            <StyledHeading
              as="h1"
              style="headingJumbo"
              color={isDark ? 'white' : 'black'}
              fluidTypographyOptions={{
                minPx: 40,
                maxPx: 80,
                viewportWidth: 5,
              }}
            >
              {title}
            </StyledHeading>

            <BulletsDescWrapper>
              {subtitle && <DescriptionWrapper>{subtitle}</DescriptionWrapper>}
            </BulletsDescWrapper>

            {eventTypes?.length === 1 ? (
              <EventDatePickerV2
                eventType={eventTypes[0].name}
                isMobile={isMobile}
              />
            ) : (
              <EventTypeOptions
                descriptorVariable={descriptorVariable}
                eventTypes={eventTypes}
                isMobile={isMobile}
              />
            )}
          </MainContentWrapper>
        </ContentWrapper>

        <ImagesWrapper
          isMobile={isMobile}
          isTablet={isTablet}
          isDesktop={isDesktop}
          imageSrc={imageSrc}
          verticalName={vertical}
        />
      </Container>
    </SliceLayout>
  );
}
